<template>
  <div v-if="provider.disabilityAccomodations.length || isConnecticut || unknownAccessibility">
    <hr v-if="!viewDetails" />
    <p class="label">
      <app-inline-svg
        :src="icon"
        :style="globalTheme.colorSecondary"/>
      <strong>{{label}}</strong>
    </p>
      <p
        v-for="(accomodation, i) in filteredAccommodations"
        :key="i">
        <strong>{{ accomodation.label }}</strong>: {{ accomodation.status}}
        <span v-if="unknownAccessibility">Unknown</span>
      </p>
  </div>
  <div v-else>
    <hr v-if="!viewDetails"/>
    <p class="label">
      <app-inline-svg
        :src="icon"
        :style="globalTheme.colorSecondary"/>
      <strong>{{label}}</strong>
    </p>
    <p>
      <span>Not Handicap Accessible</span>
    </p>
  </div>
</template>
<script lang="ts">
   import {defineComponent} from 'vue'
  import { Provider,SearchResultCardLabels,AccessibilityDetails,AccessibilityDetail } from '@/types'
  import IsConnecticut from '@/mixins/IsConnecticut.ts'
  import { camelCase } from "change-case";
  export default defineComponent({
    mixins: [IsConnecticut],
    props: {
      provider: {
        required: true,
        type: Object as () => Provider
      },
      unknownAccessibility: {
        type: Boolean
      },
      label: {
        required: true,
        type: String
      },
      icon: {
        required: true,
        type: String
      },
      viewDetails: {
        required: false,
        type: Boolean
      },
      accessibilityDetails: {
        required: false,
        type: Object as () => AccessibilityDetails
      }
    },
    computed: {
      accessibilityMap(): Record<string, boolean> {
        if (!this.accessibilityDetails) return {};
        const map: Record<string, boolean> = {};
        
        Object.keys(this.accessibilityDetails).forEach((key: string) => {
            const detail = this.accessibilityDetails?.[key];
            if (detail) {
              map[key] = detail.hide;
            }
        });
        return map;
      },
      filteredAccommodations(): Array<{label: string, status: string}> {
        if (!this.provider?.disabilityAccomodations) return [];
        
        return this.provider.disabilityAccomodations
          .filter((accommodation: string) => {
            const camelCaseKey = camelCase(accommodation.split(" : ")[0]);
            return this.accessibilityDetails?.[camelCaseKey] && !this.accessibilityMap[camelCaseKey];
          })
          .map((accommodation: string) => {
            const [label, status] = accommodation.split(" : ");
            const camelCaseKey = camelCase(label);
            const localizedLabel = this.accessibilityDetails?.[camelCaseKey]?.label || label;
            return {
              label: localizedLabel,
              status: status
            };
          });
      },
    },
  })
</script>
